<template>
  <div>
    <van-nav-bar title="自助提箱" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <van-form @submit="onSubmit">
      <van-field v-model="boxno" name="boxno" maxlength="11" label="箱号" format-trigger="onBlur"
                 placeholder="请输入箱号或7位数字"/>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Form} from 'vant';

Vue.use(Form);

export default {
  data() {
    return {
      name: '',
      tel: '',
      boxno: '',
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push({path: "/container-yard/home"});
    },
    onSubmit(values) {
      let querystring = require("querystring");
      this.$api.post("wx/container-yard/out",
          querystring.stringify({
            boxno: values.boxno,
            tel: localStorage.getItem("tel"),
            name: localStorage.getItem("name"),
            carno: localStorage.getItem("carno"),
          })
      ).then(({data}) => {
        if (data.status == 1) {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
            this.$router.push({path: "/container-yard/home"});
          });
        } else {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
          });
        }
      });
    },
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/container-yard/out.vue